import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import './CarSale.css'; // Assuming the CSS will be in this file
import { IoCarSportSharp } from "react-icons/io5";
import axios from 'axios'; // Import axios for making HTTP requests
import { FaCarCrash } from "react-icons/fa";
import { IoPersonCircle } from "react-icons/io5";
import { Button, Snackbar} from '@mui/material';
import ScrollToTop from '../ScrollToTop';
import { imagesWithText } from '../Home Page/HomePage';
import Carousel from '../Carousel/Carousel';
import { Helmet } from "react-helmet";




const ListYourVehicleForm = () => {
  const [formStep, setFormStep] = useState(1); // Track the form step
  const [carMakes, setCarMakes] = useState([]); // State to hold car makes
  const [selectedMake, setSelectedMake] = useState(''); // State to hold selected manufacturer
  const [carModels, setCarModels] = useState([]); // State to hold models based on selected make
  const [selectedModel, setSelectedModel] = useState(''); // State to hold selected model
  const [carVariants, setCarVariants] = useState([]); // State to hold variants based on selected model
  const { register, handleSubmit, trigger,setValue,setError, clearErrors, formState: { errors } } = useForm(); // Use trigger for manual validation
  const [images,setImages]=useState([]);
  const [imageUrls,setImageUrls]=useState([]);
  const [imageError, setImageError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);


  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [formData,setFormData] =useState({
    make: '',
    model: '',
    variant: '',
    year: '',
    transmission: '',
    mileage: '',
    exteriorCondition: '',
    interiorCondition: '',
    accident:'',
    CarType:'',
    attention:'',
    keys:'',
    
    Doors:'',
    owner:'',
    Ulez:'',
    ServiceHistory:'',
    list:'no',
    seats:'',
    
    capacity:'',
    vehiclereg:'',
    ownerFirstName: '',
    ownerLastName: '',
    contact: '',
    email: '',
    exteriorColor:'',
    interiorColor:'',
    imagess:[],
    videourl:'',
  });
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleFileChange = (e) => {
    const selectedFiles = e.target.files; // Get selected files
    const fileCount = selectedFiles.length; // Count selected files
    console.log(fileCount);
    if (fileCount < 3) {
      alert("Please select at least 3 files."); // Error message for less than 3 files
      return;
    }
  
    if (fileCount > 20) {
      alert("You can select up to 20 files only."); // Error message for more than 10 files
      return;
    }
  
    setImages(selectedFiles); // Store selected files if within valid range
  };
  
  const handleUpload = async () => {
    try {
      // Convert the images to an array if it's not an array already (useful if it's a FileList)
      const imageArray = Array.isArray(images) ? images : Array.from(images);
  
      // Map each image to a promise that handles the upload
      const uploadPromises = imageArray.map((image) => {
        const formData = new FormData();
        formData.append("file", image);
  
        // You can append the transformation parameters directly here for resizing the image
        // Cloudinary transformations for resizing to 600x900 pixels without stretching
        formData.append("upload_preset", "checking"); // Replace with your Cloudinary upload preset
        formData.append("folder", "ZOOM AUTOS");
  
        // Return the promise of the axios request for this image upload
        return axios.post(
          `https://api.cloudinary.com/v1_1/db2so7dyd/image/upload`, // Replace with your Cloudinary cloud name
          formData
        ).then(response => {
          // Get the URL of the uploaded image
          const imageUrl = response.data.secure_url;
          
          // Apply the transformation for resizing
          const transformedImageUrl = `${imageUrl}?w_600,h_900,c_fill`;
  
          return transformedImageUrl; // Return the transformed image URL
        })
        .catch(error => {
          console.error("Error uploading image: ", error);
          return null; // Return null if there's an error
        });
      });
  
      // Wait for all the uploads to complete in parallel
      const uploadedImageUrls = await Promise.all(uploadPromises);
  
      // Filter out any null responses due to upload errors
      const validImageUrls = uploadedImageUrls.filter(url => url !== null);
  
      // Update the state with the valid image URLs
      setImageUrls(validImageUrls);
  
      return validImageUrls;
    } catch (error) {
      console.error('Error in parallel image upload:', error);
      return [];
    }
  };
  
  
  // Fetch car makes from the backend when the component mounts
  useEffect(() => {
    const fetchCarMakes = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/make'); // Adjust the URL as needed
  
        // Sort by manufacturer in ascending order before setting state
        const sortedMakes = response.data.sort((a, b) => 
          a.manufacturer.localeCompare(b.manufacturer)
        );
  
        setCarMakes(sortedMakes); // Set the sorted car makes data to state
      } catch (error) {
        console.error('Error fetching car makes:', error);
      }
    };
  
    fetchCarMakes(); // Call the function when the component mounts
  }, []);
  
  function getCurrentYear() {
    const today = new Date(); // Create a new Date object for the current date and time
    return today.getFullYear(); // Return the year (e.g., 2024)
}
const [regError, setRegError] = useState("");

const validateVehicleRegistration = (reg) => {
  const ukRegExp = /^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$/; // UK format: two letters, two numbers, three letters
  if (ukRegExp.test(reg)) {
    setRegError("");
    clearErrors("vehiclereg"); // Clear React Hook Form's error if valid
    return true;
  } else {
    setRegError("Invalid Vehicle Registration format.");
    setError("vehiclereg", {
      type: "manual",
      message: "Invalid Vehicle Registration format.",
    }); // Set React Hook Form's error
    return false;
  }
};

const handleregValidationOnChange = (e) => {
  const reg = e.target.value.toUpperCase(); // Convert to uppercase for uniformity
  validateVehicleRegistration(reg);
};

const [error, setErrors] = useState({
  
  vehiclereg: '',
});
const [urlerror,seturlerror]=useState("");
  
const validatevideourl = (url) => {
  if (
    url.includes("youtube.com") ||
    url.includes("youtu.be") ||
    url.includes("vimeo.com") ||
    url.includes("drive.google.com")
  ) {
    seturlerror("");
    clearErrors("videourl"); // Clear React Hook Form's error if URL is valid
    return true;
  } else {
    seturlerror("Invalid URL. Please enter a valid video URL.");
    setError("videourl", {
      type: "manual",
      message: "Invalid URL. Please enter a valid video URL.",
    }); // Set React Hook Form's error
    return false;
  }
};

  // Function to handle "Next" button with validation
  // Function to handle "Next" button with validation
  const handleNext = async () => {
    const validStep1 = await trigger(['manufacturer', 'model','vehiclereg', 'variant', 'year','seats','Ulez','history', 'keys','capacity','owner' ,'transmission', 'exteriorColor','interiorColor','Type', 'mileage', 'description', 'CarType', 'Doors', 'videourl'    ]);
    
    // // Check if images are selected from the state
    // if (images.length === 0) {
    //   setImageError("Images are required."); // Set error message for images
    //   return; // Prevent moving to the next step
    // } else if (images.length < 3 || images.length > 10) {
    //   setImageError("Please select between 3 and 10 images."); // Set error message for image count
    //   return; // Prevent moving to the next step
    // } else {
    //   setImageError(""); // Clear the error message if images are selected correctly
    // }
  
    // // Validate step 1 fields
    if (!validStep1) {
      const firstErrorStep1 = Object.keys(errors).find(field => ['manufacturer', 'model','vehiclereg', 'variant', 'year','seats','Ulez','history', 'keys','capacity','owner' ,'transmission', 'exteriorColor','interiorColor','Type', 'mileage', 'description', 'CarType', 'Doors','videourl'    ].includes(field));
  
      if (firstErrorStep1) {
        const fieldRef = document.querySelector(`[name="${firstErrorStep1}"]`);
        if (fieldRef) {
          fieldRef.focus(); // Focus on the first error field
        }
      }
      return; // Prevent moving to the next step
    }
  
    // if (formStep === 2) {
    //   const validStep2 = await trigger(['exteriorCondition', 'interiorCondition', 'accident']);
    //   if (!validStep2) {
    //     const firstErrorStep2 = Object.keys(errors).find(field => ['exteriorCondition', 'interiorCondition', 'accident'].includes(field));
    //     if (firstErrorStep2) {
    //       const fieldRef = document.querySelector(`[name="${firstErrorStep2}"]`);
    //       if (fieldRef) {
    //         fieldRef.focus();
    //       }
    //     }
    //     return; // Prevent moving to the next step
    //   }
    // }
  
    // If validations passed for the current step
    setFormStep((prevStep) => prevStep + 1);
  };
  
  


  const onSubmit = async (data) => {
    try {
        // First, upload the images and get the URLs
        const imageUrls = await handleUpload();

        // Check if imageUrls is valid
        if (!Array.isArray(imageUrls) || imageUrls.length === 0) {
            throw new Error("No images uploaded.");
        }
        setLoading(true);
        // Now, submit the form data along with the image URLs in the `imagess` field
        const response = await axios.post('https://zoomautos.co.uk/car', {
            formType: 'CarForm',
            ...data, // Spread the rest of the form data
            list:"yes",
            imagess: imageUrls // Add the image URLs to the `imagess` field
        });

        console.log("Form submitted successfully:", response.data); // Log success responsew
        setLoading(false);
        setSuccess(true);
    
        // Show success snackbar
        setSnackbar({ open: true, message: 'Form submitted and PDF sent via email!', severity: 'success' });

        // Reset the form after submission
        setFormData({
          manufacturer: '',
            model: '',
            variant: '',
            year: '',
            transmission: '',
            mileage: '',
            CarType:'',
  
            keys:'',
            list:'no',
    Doors:'',
    owner:'',
    seats:'',
    capacity:'',
    Ulez:'',
    ServiceHistory:'',
    vehiclereg:'',
    exteriorColor:'',
    interiorColor:'',
            exteriorCondition: '',
            interiorCondition: '',
            accident: '',
            ownerFirstName: '',
            ownerLastName: '',
            contact: '',
            email: '',
            price: '',
            imagess: [], // Reset the `imagess` field to an empty array
            videourl:'',
        });
        window.location.reload();
        // // Delay reload by 3 seconds
        // setTimeout(() => {
        //     window.location.reload();
        // }, 3000); // 3 seconds delay for page reload

    } catch (error) {
        console.error('Error submitting form:', error); // Log error details
        // Handle errors with proper error feedback (Snackbar or alert)
        const errorMessage = error.response ? error.response.data.message || error.message : error.message;
        setSnackbar({ open: true, message: errorMessage, severity: 'error' });
    }
};
const handleEngineCapacityChange = (event) => {
  let value = event.target.value;

  // Restrict to numbers and a single decimal point
  value = value.replace(/[^0-9.]/g, '');

  // Automatically format two-digit numbers with a decimal
  if (value.length === 2 && !value.includes('.')) {
    value = value[0] + '.' + value[1];
  }

  // Restrict to maximum of 2 digits and one decimal place
  if (/^\d{2}\.\d$/.test(value)) {
    value = value.slice(0, 4);
  } else if (/^\d{3,}/.test(value)) {
    value = value.slice(0, 2);
  }
  
setValue('capacity', value);
}
const [count, setCount] = useState(0);

const handleInputChange = (e) => {
  const remaining = 50 - e.target.value.length;
  setCount(remaining);

  if (remaining < 0) {
    triggerSetError();
  } else {
    triggerClearError();
  }
};

const triggerSetError = () => {
  setError('attention', {
    type: 'manual',
    message: 'Exceeded character limit of 50.',
  });
};

const triggerClearError = () => {
  clearErrors('attention');
};


const handleValidationOnChange = (e) => {
  const url = e.target.value;
  validatevideourl(url);
};
  
  return (
    <>
    
    <Helmet>
        <title>Home</title>
      </Helmet>
    <div className="carousel-container">
        <Carousel imagesWithText={imagesWithText} />
        <div className="overlay-text">
          <h1>List Vehicle</h1>
        </div>
      </div>
      
    
    <div className='sell-vehicle-container'>
      {/* Left Pane */}
      <div className='leftpane'>
        <h2>SELL YOUR VEHICLE</h2>
        <p>
          Interested in trading in your current vehicle? It would probably be good to have an estimate of what it’s worth first. After all, trading in a vehicle is a lot less hassle than selling it yourself.
        </p>
      </div>

      {/* Sell Vehicle Form */}
      <div className="sell-vehicle-form">
        <form onSubmit={handleSubmit(onSubmit)}>
          {formStep === 1 && (
            <>
            <ScrollToTop/>
              {/* Car Information Section */}
              <div className="form-section">
                <h2>Car Information </h2>
                <div className="form-row">
                  <div className="form-group">
                    <h3>Make</h3>
                    <input
                    placeholder='Enter Make'
                    {
                      ...register('manufacturer', { required: 'Make is required' })}/>
                      
                    
                    {errors.make && <p className="error-message">{errors.make.message}</p>}
                  </div>
                  <div className="form-group">
                    <h3>Model</h3>
                     
                    <input
                    placeholder='Enter Model'
                    {
                      ...register('model', { required: 'Model is required' })}/>
                      
                    {errors.model && <p className="error-message">{errors.model.message}</p>}
                  </div>
                  <div className="form-group">
                    <h3>Variant</h3>
                     <input type="text"
                     placeholder='Variant'
                     {...register('variant', { required: 'Variant is required' })}/>
                      
                    {errors.variant && <p className="error-message">{errors.variant.message}</p>}
                  </div>
                  </div>
                  <div className='form-row'>
                  <div className="form-group">
        <h3>Vehicle Registration</h3>
        <input
          placeholder="Enter Vehicle Registration"
          {...register("vehiclereg", { required: "Vehicle Registration is required" })}
          onChange={(e) => {
            handleregValidationOnChange(e); // Validate on each change
          }}
        />
        {errors.vehiclereg && <p className="error-message">{errors.vehiclereg.message}</p>}
        {regError && !errors.vehiclereg && <p className="error-message">{regError}</p>}
      </div>
                  </div>
                  <div className='form-row'>
                  <div className="form-group">
                    <h3>Attention Grabber <p style={{color:'black'}}>Character Count: {count}</p></h3>
                    
                    <input
        placeholder="Enter Attention Grabber for Your car"
        {...register('attention', {
          required: 'Attention grabber is required',
          maxLength: {
            value: 50,
            message: 'Attention grabber cannot exceed 50 characters',
          },
        })}
        onChange={(e) => {
          handleInputChange(e);
        }}
      />
                    
                  </div>
                  </div>
                  
     
     
  
                  <div className='form-row'>
        <div className='form-group'>
          <h3>Engine Capacity (L)</h3>
          <input
            type="text" /* Use 'text' to handle custom formatting */
            placeholder="Engine Capacity"
            {...register('capacity', {
              required: 'Engine Capacity is required',
              pattern: {
                value: /^\d{1,2}(\.\d)?$/,
                message: 'Enter a valid engine capacity (e.g., 1.5, 10.0)',
              },
            })}
            onChange={handleEngineCapacityChange}
          />
          {errors.capacity && (
            <span className="error-message">{errors.capacity.message}</span>
          )}
        </div>
      
  <div className="form-group">
  <h3>Mileage</h3>
  <input
    type="number"
    {...register('mileage', {
      required: 'Mileage is required', // Validation to ensure mileage is provided
      min: {
        value: 1,
        message: 'Mileage must be greater than 0' // Validation message for values less than or equal to 0
      }
    })}
    placeholder="Mileage"
  />
  {errors.mileage && <span className="error-message">{errors.mileage.message}</span>} {/* Error message display */}
</div>
<div className="form-group">
    <h3>Year</h3>
    <input
        type="number"
        {...register('year', {
            required: 'Year is required',
            min: {
                value: 2001,
                message: 'Year must be greater than 2000'
            },
            max: {
                value: getCurrentYear(), // Use the variable here
                message: `Year must be less than ${getCurrentYear()}`
            },
            validate: (value) => value <= getCurrentYear() || `Year must be less than ${getCurrentYear()}`
        })}
        placeholder="Year"
    />
    {errors.year && <p className="error-message">{errors.year.message}</p>}
</div>
              
                </div>

                <div className="form-row">
                  
  <div className='form-group'>
  <h3>Fuel Type</h3>
<select 
  {...register('Type', { required: 'Fuel Type is required' })}
  defaultValue="" // This ensures that no value is selected initially
>
  <option value="" disabled hidden>
    Fuel Type
  </option>
  <option value="Diesel">Diesel</option>
  <option value="Diesel Hybrid">Diesel Hybrid</option>
  <option value="Electric">Electric</option>
  <option value="Petrol">Petrol</option>
  <option value="Petrol Hybrid">Petrol Hybrid</option>
  <option value="Petrol Plugin Hybrid">Petrol Plugin Hybrid</option>
</select>
{errors.Type && <span className="error-message">{errors.Type.message}</span>}
</div>     
                  <div className="form-group">
                  <h3>Transmission</h3>
<select 
  {...register('transmission', { required: 'Transmission is required' })} // Ensure both options are registered correctly
  defaultValue="" // This ensures that "Transmission Type" is displayed initially
>
  <option value="" disabled hidden>
    Transmission Type
  </option>
  <option value="Automatic">Automatic</option>
  <option value="Manual">Manual</option>
</select>

{errors.transmission && <p className="error-message">{errors.transmission.message}</p>}

                  </div>
                  
                  <div className="form-group">
                  <h3>Keys</h3>
<select 
  {...register('keys', { required: 'Number of keys is required' })} // Ensure both options are registered correctly
  defaultValue="" // Ensures "Number of keys" is selected initially
>
  <option value="" disabled hidden>
    Number of keys
  </option>
  <option value="1">1</option>
  <option value="2">2</option>
</select>

{errors.keys && <p className="error-message">{errors.keys.message}</p>}
                  </div>
                  
                  
                </div>
                <div className='form-section'>
<div className='form-row'>
  <div className='form-group'>
  <h3>Car Type</h3>
<select 
  {...register('CarType', { required: 'Car Type is required' })} // Ensure both options are registered correctly
  defaultValue="" // Set the default value to show the placeholder
>
  <option value="" disabled hidden>
    Car Type
  </option>
  <option value="SEDAN">SEDAN</option>
  <option value="SUV">SUV</option>
  <option value="HATCHBACK">HATCHBACK</option>
  <option value="COUPE">COUPE</option>
  <option value="VAN">VAN</option>
  <option value="CONVERTIBLE">SUPER CAR</option>
  <option value="SALOON">SALOON</option>
  <option value="ESTATE">ESTATE</option>
</select>

{errors.CarType && <span className="error-message">{errors.CarType.message}</span>} {/* Error message display */}
</div>
  <div className='form-group'>
  <h3>Number of Doors</h3>
<select 
  {...register('Doors', { required: 'Number of Doors is required' })} // Ensure both options are registered correctly
  defaultValue="" // Set default value to show the placeholder
>
  <option value="" disabled hidden>
    No. of Doors
  </option>
  <option value="3">3</option>
  <option value="5">5</option>
</select>

{errors.Doors && <span className="error-message">{errors.Doors.message}</span>} {/* Error message display */}

</div>

  <div className='form-group'>
  <h3>Number of Seats</h3>
<select 
  {...register('seats', { required: 'Number of seats is required' })} // Ensure both options are registered correctly
  defaultValue="" // Set default value to show the placeholder
>
  <option value="" disabled hidden>
    No. of Seats
  </option>
  <option value="2">2</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="7">7</option>
</select>

{errors.seats && <span className="error-message">{errors.seats.message}</span>} {/* Error message display */}
  </div>
</div>
</div>

                
                <div className="form-row">

<div className="form-group">
    <h3>Owner</h3>
    <input
        type="number"
        {...register('owner', {
            required: 'owner is required',
            min: {
                value: 1,
                message: 'owner must be greater than 1'
            }
            
            
        })}
        placeholder="Owner"
    />
    {errors.owner && <p className="error-message">{errors.owner.message}</p>}
</div>
                  <div className="form-group">
                    <h3>Exterior Color</h3>
                    <input type="text" {...register('exteriorColor', { required: 'Exterior Color is required' })} placeholder="Exterior Color" />
                    {errors.exteriorColor && <p className="error-message">{errors.exteriorColor.message}</p>}
                  </div>
                  <div className="form-group">
                    <h3>Interior Color</h3>
                    <input type="text" {...register('interiorColor', { required: 'Interior Color is required' })} placeholder="Interior Color" />
                    {errors.interiorColor && <p className="error-message">{errors.interiorColor.message}</p>}
                  </div>
                </div>
              
<div className='form-row'>
<div className='form-group'>
  <h3>Is Your Car Ulez Exempt</h3>
  <select 
    {...register('Ulez', { required: 'Ulez is required' })} // Ensure both options are registered correctly
    defaultValue="" // Ensure placeholder is selected by default
  >
    <option value="" disabled hidden>
      Ulez exempt?
    </option>
    <option value="yes">Yes</option>
    <option value="no">No</option>
  </select>
  {errors.Ulez && <span className="error-message">{errors.Ulez.message}</span>} {/* Error message display */}

  </div>
  <div className='form-group'>
  <h3>Service History</h3>
  <select 
    {...register('ServiceHistory', { required: 'Ulez is required' })} // Ensure both options are registered correctly
    defaultValue="" // Ensure placeholder is selected by default
  >
    <option value="" disabled hidden>
      Service History
    </option>
    <option value="Full Service Histroy">Full Service History</option>
    <option value="Full Dealership Histroy">Full Dealership History</option>
    <option value="Part Service Histroy">Part Service History</option>
    <option value="No Service Histroy">No Service History</option>
  </select>
  {errors.ServiceHistory && <span className="error-message">{errors.ServiceHistory.message}</span>} {/* Error message display */}

  </div>
  </div>

              <div className="form-section">
              <div className="form-group">
                  
              <h3>Upload Car Images</h3>
              <p style={{color:"black", marginTop:'-10px'}}>Upto 20 images</p>
              
              <input type="file" multiple name='imagess' accept="image/*" onChange={handleFileChange} />
              {imageError && <span className="error-message">{imageError}</span>}
              <p style={{color:'red', fontSize:'10px'}}><strong>Please provide pictures if there is any damage</strong></p>
              </div>

              
              </div>
              <div className='form-row'>
  <div className='form-group'>
  <h3>URL for Video</h3>
          <input
            placeholder="Enter URL for Video"
            {...register("videourl", { required: "URL is required" })}
            onChange={(e) => {
              handleValidationOnChange(e); // Validate on each change
            }}
          />
          {errors.videourl && <p className="error-message">{errors.videourl.message}</p>}
          {urlerror && !errors.videourl && <p className="error-message">{urlerror}</p>}
        </div>
</div>
              <div className="form-section">
             <div className="form-group">
        <h3>Description</h3>
        <textarea 
          {...register('description', {
            required: 'Description is required', // Validation rule
            minLength: {
              value: 50,
              message: 'Description must be at least 50 characters long' // Additional validation rule
            }
          })} 
          placeholder="Please specify the details of your car e.g. the documents you have!"
          rows={8}  // Adjust the number of rows for the textarea
          className="form-control"  // Add any necessary styling if required
        />
        {errors.description && <span className="error-message">{errors.description.message}</span>}
      </div>
      </div>
      </div>

              

              {/* Submit or Next Button */}
              
                <button type="button" className="contact-button" onClick={handleNext}>
                  Next
                </button>
              
            </>
          )}

          {
            formStep === 2 && (
              <>
              <ScrollToTop/>
              <div className="form-section">
              <h2>Car Information <IoCarSportSharp /></h2>
              <h3>What is the Exterior Condition?</h3>
<div className="radiocontainer">
  {[
    'Poor',
    'Average',
    'Good',
    'Clean',
    'Excellent',
    'New',
  ].map((condition) => (
    <label key={condition}>
      <input
        type="radio"
        {...register('exteriorCondition', { required: 'Exterior condition is required' })}
        value={condition}
      />
      <span>{condition}</span>
    </label>
  ))}
</div>
{errors.exteriorCondition && (
  <span style={{ color: 'red' }}>{errors.exteriorCondition.message}</span>
)}
</div>
<div className='form-section'>
<h3>What is the Interior Condition?</h3>    
<div className="form-row">
<div className='radiocontainer'>
<label>
          <input
            type="radio"
            {...register('interiorCondition', { required: 'Interior condition is required' })}
            value="Poor"
          />
          <span>Poor</span>
        </label>
        <label>
          <input
            type="radio"
            {...register('interiorCondition')}
            value="Average"
          />
         <span> Average</span>
        </label>
        <label>
          <input
            type="radio"
            {...register('interiorCondition')}
            value="Good"
          />
          <span>Good</span>
        </label>
        <label>
          <input
            type="radio"
            {...register('interiorCondition')}
            value="Clean"
          />
         <span>Clean</span>
        </label>
        <label>
          <input
            type="radio"
            {...register('interiorCondition')}
            value="Excellent"
          />
         <span>Excellent</span>
        </label>
        <label>
          <input
            type="radio"
            {...register('interiorCondition')}
            value="New"
          />
         <span>New</span>
        </label>
        </div>

        
      </div>
      {errors.interiorCondition && <p className="error-message">{errors.interiorCondition.message}</p>}
      </div>
      <div className='form-section'>
  <h3>Has This Car Ever Been in an Accident?<FaCarCrash/></h3>
                <div className="form-row">
                  <div className='radiocontainer'>
                <label>
    <input
      type="radio"
      {...register('accident', { required: 'Accident history is required' })}
      value="Yes"
    />
    <span>Yes</span>
  </label>
  <label>
    <input
      type="radio"
      {...register('accident', { required: 'Accident history is required' })} // Ensure both options are registered correctly
      value="No"
    />
   <span> No</span>
  </label>
  </div>
</div>
{errors.accident && <span className="error-message">{errors.accident.message}</span>} {/* Error message display */}
</div>


              <div className="form-navigation">
              <button type="button" className='contact-button' onClick={() => setFormStep(1)}>Back</button>
                <button type="button"  className= 'contact-button' onClick={handleNext} style={{marginLeft:'40px'}}>
                  Next
                </button>
              </div>
              </>
            )
          }
          {
            formStep === 3 && (
              <>
              <ScrollToTop/>
              <div className="form-section">
              <h2>Owner Information <IoPersonCircle /></h2>
              <div className="form-row">
  <div className="form-group">
    <h3>First Name</h3>
    <input
      type="text"
      {...register('ownerFirstName', {
        required: 'First name is required' // Validation message if empty
      })}
      placeholder="First Name"
    />
    {errors.ownerFirstName && <span className="error-message">{errors.ownerFirstName.message}</span>} {/* Error message display */}
  </div>
  <div className="form-group">
    <h3>Last Name</h3>
    <input
      type="text"
      {...register('ownerLastName', {
        required: 'Last name is required' // Validation message if empty
      })}
      placeholder="Last Name"
    />
    {errors.ownerLastName && <span className="error-message">{errors.ownerLastName.message}</span>} {/* Error message display */}
  </div>
</div>

                {/* Exterior/Interior Color */}
                <div className="form-row">
                <div className="form-group">
  <h3>Contact</h3>
  <input
    type="text"
    {...register('contact', {
      required: 'contact is required' // Validation message if empty
    })}
    
    
    placeholder="Contact Number"
  />
  {errors.contact && <span className="error-message">{errors.contact.message}</span>} {/* Error message display */}
</div>

                  <div className="form-group">
                    <h3>Customer Email</h3>
                    <input type="text" {...register('Email')} placeholder="Email" />
                  </div>
                  
                </div>
                <div className="form-row">
                
                <div className="form-group">
                    <h3>Message</h3>
                    <input type="textarea" {...register('Message')} placeholder="Message" />
                  </div>
              </div>
              
              <div className="form-navigation">
              <button type="button" className='contact-button' onClick={() => setFormStep(2)}>Back</button>
                <button type="submit" className='contact-button' onClick={handleSubmit(onSubmit) }style={{marginLeft:'40px'}}>
                  Submit
                </button>
              </div>
              </div>
              </>
              
            )
            
          }
        </form>
      </div>
      <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbar.message}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          className="MuiSnackbar-root"
          action={
            <Button color="inherit" className="MuiButton-text" onClick={handleCloseSnackbar}>
              Close
            </Button>
            
          }
        />
    </div>
    {loading && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Submitting...</div>
        </div>
      )}

      {/* Success Overlay */}
      {success && (
        <div className='overlayStyle'>
          <div className='successStyle' >{formData.servicetype} Form Submitted Successfully!</div>
        </div>
      )}
    </>
  );
};

export default ListYourVehicleForm;
